import { createApp } from 'vue'
// import Vue3PdfjsViewer from 'vue3-pdfjs-viewer'
import App from './App.vue'
import 'lib-flexible'
import "./assets/css/commonStyle.scss";
import "./assets/css/tailwind.css";
import "./utils/rem";
// createApp(App).mount('#app')
import router from './router'
import  Content from './components/Content.vue'
// createApp(App).use(router).mount('#app')
// 全局配置图片基础URL
const imgurl = 'https://mf8.mufengweilai.com/api/question_bank/swagger-ui.html#/'


const app = createApp(App)
app.use(router)
// app.use(Vue3PdfjsViewer)
app.component('Content',  Content)
// 将imgurl配置添加到全局属性中
app.config.globalProperties.$imgurl = imgurl

app.mount('#app')